import type { GuideSourceDetails } from "@expert/solve-tools/src/guides/types";

import { isGuideSupported } from "@expert/solve-tools";

import type { usePartner } from "@/sdk";

import { isDeviceActivationIntent, isDeviceActivationQueue, isDeviceActivationSupportNumber } from "./isActivation";

interface OpenActivationGuideProps {
    disableAutomaticOpen: boolean;
    intent?: string;
    isCustomerSession: boolean;
    isCustomerVerificationComplete: boolean;
    isDeviceActivationGuideIntentAutoOpenEnabled: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
    partner: ReturnType<typeof usePartner>;
    requireVerification: boolean;
    sessionId: string;
    supportNumberCalled?: string;
    queueName?: string;
}
export function shouldOpenActivationGuide({
    disableAutomaticOpen,
    intent,
    isCustomerSession,
    isCustomerVerificationComplete,
    isDeviceActivationGuideIntentAutoOpenEnabled,
    isGuideOpen,
    isLoadingSimplrSession,
    partner,
    requireVerification,
    sessionId,
    supportNumberCalled,
    queueName,
}: Readonly<OpenActivationGuideProps>): {
    shouldOpenGuide: boolean;
    sourceDetails?: GuideSourceDetails;
} {
    if (
        !isGuideSupported(sessionId, "Device Activation") ||
        isGuideOpen ||
        !isCustomerSession ||
        disableAutomaticOpen ||
        isLoadingSimplrSession
    )
        return { shouldOpenGuide: false };

    // Redesign (V2) holds auto-open until the customer is verified, so we don't surface a guided
    // flow before the expert has verified them. Legacy is intentionally exempt (requireVerification=false).
    if (requireVerification && !isCustomerVerificationComplete) return { shouldOpenGuide: false };

    if (isDeviceActivationIntent(intent) && isDeviceActivationGuideIntentAutoOpenEnabled)
        return { shouldOpenGuide: true, sourceDetails: "intent" };
    if (isDeviceActivationQueue({ partner, queueName })) return { shouldOpenGuide: true, sourceDetails: "queue" };
    if (isDeviceActivationSupportNumber({ partner, supportNumberCalled }))
        return { shouldOpenGuide: true, sourceDetails: "tfn" };

    return { shouldOpenGuide: false };
}
